import React, { RefObject, useEffect, useMemo, useState } from "react";
import { FaFilter, FaUser } from "react-icons/fa";
import { clientMasterServicer } from "../../Commen_Services/clientmaster.service";
import { Autocomplete, Box, FormControl, FormHelperText, IconButton, MenuItem, Select, TablePagination, TextField, useTheme } from "@mui/material";
import { useParams } from "react-router-dom";
import { Add, Edit, KeyboardArrowLeft, KeyboardArrowRight, Save } from "@mui/icons-material";
import Popup from 'reactjs-popup';
import { IoClose } from "react-icons/io5";
import { GrPowerReset } from "react-icons/gr";
import LastPageIcon from '@mui/icons-material/LastPage';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import DeleteIcon from '@mui/icons-material/Delete';
import customToast from "../Toast/CustomToast";

interface ColumnData {
    Column_name: string;
    Header_name: string;
    Is_Display: boolean;
    Is_Export: boolean;
    Is_active: boolean;
}

interface RowData {
    [key: string]: any;
}

interface TablePaginationActionsProps {
    count: number;
    page: number;
    rowsPerPage: number;
    onPageChange: (
        event: React.MouseEvent<HTMLButtonElement>,
        newPage: number,
    ) => void;
}


const ProductKeyListMaster: React.FC = () => {

    const { clientId } = useParams();
    const [columnData, setColumnData] = useState<ColumnData[]>([]);
    const [clientData, setClientData] = useState<any>({});
    const [tableData, setTableData] = useState<RowData[]>([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortConfig, setSortConfig] = useState<{ key: string, direction: 'asc' | 'desc' } | null>(null);
    const displayColumns = columnData.filter(col => col.Is_Display);
    const [showUpdatePopup, setUpdatePopup] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [productMappingPopup, setProductMappingPopup] = useState(false);
    const [refreshData, setRefreshData] = useState(false);
    const [productmenuList, setProductMenuList] = useState([]);
    const [productKeyList, setProductKeyList] = useState<any[]>([]);
    const [selectedProduct, setSelectedProduct] = useState<any>({ OptionName: '' });
    const [primatyKeyData, setPrimaryKeyData] = useState<any>({});
    const [expireDate, setExpireDate] = useState<any>("");
    const [inputs, setInputs] = useState({
        Product_Count: '',
        PK_EXP_DATE: '',
        CS_PRD_ID: ''
    });
    const [error, setError] = useState({
        Product_Count: '',
        PK_EXP_DATE: '',
        CS_PRD_ID: ''
    });
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [rowsPerPageForTable, setRowsPerPageForTable] = React.useState<number>(5);
    const [page, setPage] = React.useState<number>(0);
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = productKeyList.slice(indexOfFirstRow, indexOfLastRow);
    const totalPages = Math.ceil(productKeyList.length / rowsPerPage);
    const displayProductColumns = [
        {
            "Column_name": "pK_PRD__ID",
            "Header_name": "Product Id",
            "Field_Type": "TEXT"
        },
        {
            "Column_name": "pK_KEY",
            "Header_name": "Product Key",
            "Field_Type": "TEXT"
        },
        {
            "Column_name": "pK_StoreCode",
            "Header_name": "Store Code",
            "Field_Type": "TEXTFIELD"
        },
        {
            "Column_name": "pK_EXP_DATE",
            "Header_name": "Expire Date",
            "Field_Type": "DATE"
        }
    ];

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPageForTable(parseInt(event.target.value, 10));
        setPage(0);
    };


    function TablePaginationActions(props: TablePaginationActionsProps) {
        const theme = useTheme();
        const { count, page, rowsPerPage, onPageChange } = props;

        const handleFirstPageButtonClick = (
            event: React.MouseEvent<HTMLButtonElement>,
        ) => {
            onPageChange(event, 0);
        };

        const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
            onPageChange(event, page - 1);
        };

        const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
            onPageChange(event, page + 1);
        };

        const handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
            onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
        };

        return (
            <Box sx={{ flexShrink: 0, ml: 2.5 }}>
                <IconButton
                    onClick={handleFirstPageButtonClick}
                    disabled={page === 0}
                    aria-label="first page"
                >
                    {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
                </IconButton>
                <IconButton
                    onClick={handleBackButtonClick}
                    disabled={page === 0}
                    aria-label="previous page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                </IconButton>
                <IconButton
                    onClick={handleNextButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="next page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                </IconButton>
                <IconButton
                    onClick={handleLastPageButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="last page"
                >
                    {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
                </IconButton>
            </Box>
        );
    }

    useEffect(() => {
        const fetchTableData = async () => {
            console.log(clientId, 'clientId');
            const { data: tabledatafromAPI } = await clientMasterServicer.GetProdKeyListByClientID(Number(clientId));
            console.log(tabledatafromAPI);
            setClientData(tabledatafromAPI?.clientDetails);
            setColumnData(tabledatafromAPI?.columnDetails);
            setTableData(tabledatafromAPI?.productKeyList);
        }
        const fetchDropDownMenu = async () => {
            const { data: tabledatafromAPI } = await clientMasterServicer.getProductListDropMenu();
            console.log(tabledatafromAPI);
            const transformedData = tabledatafromAPI?.map((item: { [x: string]: any; }) => ({
                OptionID: item[Object.keys(tabledatafromAPI[0])[0]],
                OptionName: item[Object.keys(tabledatafromAPI[0])[1]] === undefined ? item[Object.keys(tabledatafromAPI[0])[0]] : item[Object.keys(tabledatafromAPI[0])[1]]
            }));
            setProductMenuList(transformedData);
        }
        fetchTableData();
        fetchDropDownMenu();
    }, [refreshData])

    useEffect(() => {

    }, [])

    const sortedData = useMemo(() => {
        let filteredData = tableData.filter(row =>
            displayColumns.some(col =>
                String(row[col.Column_name] ?? '')
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase())
            )
        );

        if (sortConfig !== null) {
            filteredData = [...filteredData].sort((a, b) => {
                const aVal = a[sortConfig.key];
                const bVal = b[sortConfig.key];
                if (aVal === bVal) return 0;
                return (aVal > bVal ? 1 : -1) * (sortConfig.direction === 'asc' ? 1 : -1);
            });
        }
        const currentTableRows = filteredData.slice(page * rowsPerPageForTable, page * rowsPerPageForTable + rowsPerPageForTable);
        return currentTableRows;
    }, [searchTerm, sortConfig, tableData, page, rowsPerPageForTable]);

    const handleSort = (key: string) => {
        setSortConfig(prev => {
            if (prev?.key === key) {
                return { key, direction: prev.direction === 'asc' ? 'desc' : 'asc' };
            }
            return { key, direction: 'asc' };
        });
    };

    const handleUpdatebutton = (PK_data: any) => {
        console.log(PK_data);
        setUpdatePopup(true);
        setPrimaryKeyData(PK_data);
        const date = new Date(PK_data.PK_EXP_DATE);
        const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        setExpireDate(formattedDate);
    }

    const handleChangeforExpireDate = ((event: any) => {
        const name = event.target.name;
        const value = event.target.value;
        setExpireDate(value);
    });

    const handleClose = () => {
        setShowConfirmation(false);
    };

    const handleConfirmExit = () => {

        const productData = {
            "pK_ID": primatyKeyData.PK_ID,
            "pK_EXP_DATE": expireDate
        }

        clientMasterServicer.UpdateProductKeyExpireDate(productData).then(user => {
            if (user.statusCode == 200) {
                if (user.status === false) {
                    //console.log(user.data);
                    customToast.Warning(user.message);
                }
                else {
                    customToast.success(user.message);
                }
            }
        });
        setRefreshData(!refreshData);
        setShowConfirmation(false);
    };

    const handleChange = (event: any) => {
        const name = event.target.name;
        const value = event.target.value;
        if (name == "Product_Count") {
            setError((prevErrors) => ({ ...prevErrors, Product_Count: "" }));
        }
        setInputs((values: any) => ({ ...values, [name]: value }))
    };

    const generateProductKey = (id: number): string => {
        return `${id}-${Math.random().toString(36).substring(2, 10).toUpperCase()}`;
    };

    const handleGenerateProductKeybtn = () => {

        if (inputs.CS_PRD_ID == "" || inputs.Product_Count == "") {
            if (inputs.CS_PRD_ID == "") {
                setError((prevErrors) => ({ ...prevErrors, CS_PRD_ID: "Please select product" }));
            }
            if (inputs.Product_Count == "") {
                setError((prevErrors) => ({ ...prevErrors, Product_Count: "Please enter valid count." }));
            }
        }
        else {
            const productKeyGenerateParams = {
                "cL_CODE": clientData.CL_CODE,
                "prD_ID": selectedProduct.OptionID,
                "productKeyQTY": Number(inputs.Product_Count)
            }

            clientMasterServicer.GenerateDyanmicProductKeyList(productKeyGenerateParams).then(user => {
                if (user.statusCode == 200) {
                    if (user.status === false) {
                        customToast.Warning(user.message);
                    }
                    else {
                        const filteredList = productKeyList.filter(item => item.pK_PRD__ID !== selectedProduct.OptionID);
                        const newProducts = user.data;
                        setProductKeyList([...filteredList, ...newProducts]);
                        setSelectedProduct({ OptionName: '' });
                        setInputs((values: any) => ({ ...values, "CS_PRD_ID": '', "Product_Count": '' }));
                    }
                }
            });
        }
    };

    const deleteMapProduct = (data: any) => {
        const filteredList = productKeyList.filter(item => item.pK_KEY !== data.pK_KEY);
        setProductKeyList([...filteredList]);
    }

    const closePopup = () => {
        setProductKeyList([]);
        setSelectedProduct({ OptionName: '' });
        setInputs((values: any) => ({ ...values, "CS_PRD_ID": '', "Product_Count": '' }));
        setError((values: any) => ({ ...values, "CS_PRD_ID": '', "Product_Count": '' }));
        setProductMappingPopup(false);

    }


    const InsertProductKeyList = () => {

        if (productKeyList.length == 0) {
            customToast.error("Please assign atleast one product.");
        }
        else {
            const productKeyListData = {
                "cL_ID": clientId,
                "productKeyLists": productKeyList
            }

            clientMasterServicer.InsertProductKeyList(productKeyListData).then(user => {
                if (user.statusCode == 200) {
                    if (user.status === false) {
                        //console.log(user.data);
                        customToast.Warning(user.message);
                    }
                    else {
                        customToast.success(user.message);
                    }
                }
            });
            setRefreshData(!refreshData);
            closePopup();
        }
    }

    useEffect(() => {
        setCurrentPage(1);
    }, [productKeyList]);

    const handleStoreChange = (event: any, row: any, col: any) => {
        const { value } = event.target;
        row.pK_StoreCode = value;
    };



    return (<>
        <div>
            <div className="shadow">
                <div className="bg-line">
                    <span className="bg-head"><FaUser /> &nbsp;Product Key List Master</span>
                </div>
                <hr className="colorgraph" />
            </div>
        </div>
        <div style={{ marginLeft: "5px", marginTop: "5px" }}>

            <div style={{
                marginBottom: "10px", marginTop: "5px",
                border: '1px solid #ddd',
                borderRadius: '8px',
                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.42)',
                background: 'rgb(221 230 241)',
            }}
            >
                <div
                    style={{
                        padding: "0px 8px",
                        marginBottom: "5px",
                        background: 'rgb(221 230 241)'
                    }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 25px', fontSize: '13px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}><strong style={{ color: 'var(--body-main-dark-color)' }}>Client Name:&nbsp;</strong> <span>{clientData.CL_NAME}</span></div>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}><strong style={{ color: 'var(--body-main-dark-color)' }}>GST No:&nbsp;</strong> <span>{clientData.CL_GST_NO}</span></div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}><strong style={{ color: 'var(--body-main-dark-color)' }}>Client Code:&nbsp;</strong> <span>{clientData.CL_CODE}</span></div>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}><strong style={{ color: 'var(--body-main-dark-color)' }}>Client Address:&nbsp;</strong> <span>{clientData.CL_ADDRESS}</span></div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}><strong style={{ color: 'var(--body-main-dark-color)' }}>Created Date:&nbsp;</strong> <span>{clientData.CL_CREATED_DATE ? new Date(clientData.CL_CREATED_DATE).toLocaleDateString('en-GB', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true,
                            }) : ''}</span></div>
                        </div>
                    </div>
                    <div
                        key={clientData.CL_NAME}
                        style={{
                            marginLeft: "20px",
                            marginBottom: "10px",
                            padding: "5px",
                            marginTop: "10px"
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                cursor: "pointer",
                                marginTop: '-25px',
                                fontSize: '13px'
                            }}
                        >
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '0px 15px' }}>
            <FormControl variant="standard">
                <TextField
                    variant="standard"
                    label="search"
                    onChange={e => setSearchTerm(e.target.value)}
                    value={searchTerm}
                    InputLabelProps={{
                        style: {
                            color: 'var(--body-main-dark-color)',
                            fontSize: '12px',
                            borderColor: 'red',
                        },
                    }}
                    InputProps={{
                        style: {
                            width: '250px',
                        }
                    }}

                />
            </FormControl>
            <div>
                <button className={`btn123 `} onClick={() => {
                    setProductMappingPopup(true);
                }} style={{ padding: 14, backgroundColor: 'var(--body-main-dark-color)', color: '#fff' }}>Add New</button>
            </div>
        </div>
        <div className="p-4 font-sans">
            <div
                className="table-wrapper"
                style={{
                    width: "100%",
                    maxHeight: "300px",
                    overflowY: "auto",
                    border: "1px solid #ddd",
                }}
            >
                {/* Table Header */}
                <table style={{ width: "100%", tableLayout: "fixed", borderCollapse: "collapse" }}>
                    <colgroup>
                        {displayColumns.map((col, index) => (
                            <col key={index} style={{ width: `${100 / (displayColumns.length + 1)}%` }} />
                        ))}
                        <col style={{ width: "100px" }} />
                    </colgroup>
                    <thead>
                        <tr
                            style={{
                                backgroundColor: "var(--body-main-light-color)",
                                fontSize: "13px",
                                fontWeight: "bold",
                                color: "var(--body-main-dark-color)",
                            }}
                        >
                            {displayColumns.map((col) => (
                                <td
                                    key={col.Column_name}
                                    className="border px-4 py-2 cursor-pointer bg-gray-100"
                                    style={{
                                        padding: "5px",
                                        position: "sticky",
                                        top: 0,
                                        zIndex: 2,
                                        background: "var(--body-main-light-color)",
                                    }}
                                    onClick={() => handleSort(col.Column_name)}
                                >
                                    {col.Header_name || col.Column_name}
                                    {sortConfig?.key === col.Column_name &&
                                        (sortConfig.direction === "asc" ? " 🔼" : " 🔽")}
                                </td>
                            ))}
                            <td
                                style={{
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 2,
                                    background: "var(--body-main-light-color)",
                                }}
                            ></td>
                        </tr>
                    </thead>
                </table>

                {/* Scrollable Body */}
                <div style={{ maxHeight: "260px", overflowY: "auto" }}>
                    <table style={{ width: "100%", tableLayout: "fixed", borderCollapse: "collapse" }}>
                        <colgroup>
                            {displayColumns.map((col, index) => (
                                <col key={index} style={{ width: `${100 / (displayColumns.length + 1)}%` }} />
                            ))}
                            <col style={{ width: "100px" }} />
                        </colgroup>
                        <tbody style={{ background: "var(--button-color-light)" }}>
                            {sortedData.map((row, idx) => (
                                <tr key={idx} className="odd:bg-white even:bg-gray-50">
                                    {displayColumns.map((col) => (
                                        <td
                                            key={col.Column_name}
                                            className="border px-4 py-2"
                                            style={{ padding: "5px", fontSize: "13px", wordBreak: "break-word" }}
                                        >
                                            {row[col.Column_name]}
                                        </td>
                                    ))}
                                    <td>
                                        <button
                                            className="btn123"
                                            style={{
                                                backgroundColor: "var(--body-main-dark-color)",
                                                color: "var(--button-color-light)",
                                                fontSize: "11px",
                                            }}
                                            onClick={() => handleUpdatebutton(row)}
                                        >
                                            &nbsp;Update
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Pagination Footer */}
            <div>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={tableData ? tableData.length : 0}
                    rowsPerPage={rowsPerPageForTable}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                />
            </div>
        </div>

        <Popup contentStyle={{ width: '80%', padding: 0, }} position='top center' open={showUpdatePopup} onClose={() => setUpdatePopup(false)}>
            <>
                <div className="pop-main">
                    <div className="pop-head"><span className="pop-form">&nbsp;<FaFilter />&nbsp;&nbsp;Product Key Details</span></div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 25px', fontSize: '13px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}><strong style={{ color: 'var(--body-main-dark-color)' }}>Product Name:&nbsp;</strong> <span>{primatyKeyData.PRD_NAME}</span></div>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}><strong style={{ color: 'var(--body-main-dark-color)' }}>Product Key:&nbsp;</strong> <span>{primatyKeyData.PK_KEY}</span></div>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}><strong style={{ color: 'var(--body-main-dark-color)' }}>Store Code:&nbsp;</strong> <span>{primatyKeyData.PK_StoreCode}</span></div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}><strong style={{ color: 'var(--body-main-dark-color)' }}>Product Code:&nbsp;</strong> <span>{primatyKeyData.PRD_CODE}</span></div>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}><strong style={{ color: 'var(--body-main-dark-color)' }}>Product GUI ID:&nbsp;</strong> <span>{primatyKeyData.PK_GUID}</span></div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <TextField
                                sx={{ marginRight: 1 }}
                                id="standard-basic"
                                variant="standard"
                                name="PK_EXP_DATE"
                                type="date"
                                value={expireDate}
                                label="Expire Date"
                                onChange={handleChangeforExpireDate}
                                focused={!!expireDate}
                                error={!!error.PK_EXP_DATE}
                                helperText={error.PK_EXP_DATE}
                                InputProps={{
                                    inputProps: {
                                        className: expireDate ? '' : 'custom-date-input',
                                    },
                                    style: {
                                        color: expireDate ? '#243C5C' : 'black',
                                        fontSize: '14px',
                                        width: '200px',
                                        borderColor: error.PK_EXP_DATE ? 'red' : undefined,

                                    },
                                    onInput: (event: any) => {

                                        const value = event.target.value;
                                        if (value == "") {

                                        }
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        color: '#243C5C',
                                        fontSize: '12px',
                                        borderColor: error.PK_EXP_DATE ? 'red' : undefined,
                                    },
                                }}
                                FormHelperTextProps={{
                                    style: {
                                        fontSize: error.PK_EXP_DATE ? '9px' : '12px',
                                        maxWidth: '210px'
                                    },
                                }}
                            />
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px 20px' }}>
                        <div>
                            <button className='btn1' ><span><GrPowerReset /></span>Reset</button>
                        </div>
                        <div>
                            <button className='btn1' onClick={(event) => { event.stopPropagation(); setShowConfirmation(true) }} ><span><FaFilter /></span> Update</button>&nbsp;
                            <button className='btn1' onClick={(event) => { event.stopPropagation(); setUpdatePopup(false) }} ><span><IoClose /></span>Close</button>
                        </div>
                    </div>
                </div>
            </>
        </Popup>


        {showConfirmation && (
            <Popup contentStyle={{ width: 275, padding: 0 }} position='top center' open={showConfirmation} onClose={() => setShowConfirmation(false)}>
                <div className="confirmation-modal" style={{ marginBottom: '10px' }}>
                    <p>Are you sure you want to Update? <br /></p>
                    <div className="canel_btns">
                        <button className="btn123" style={{ marginRight: 10 }} onClick={handleClose}>Cancel</button>
                        <button className="btn123" style={{ marginLeft: 10 }} onClick={handleConfirmExit}>Yes </button>
                    </div>
                </div>
            </Popup>

        )}


        {productMappingPopup && (
            <Popup contentStyle={{ width: '60%', padding: 0 }} position='top center' open={productMappingPopup} onClose={() => closePopup()} closeOnDocumentClick={false}>
                <>
                    <div className="pop-main" onClick={(e) => e.stopPropagation()}>
                        <div className="pop-head" style={{ display: 'flex', justifyContent: 'space-between' }}><span className="pop-form" style={{ marginTop: '0%' }}>&nbsp;<FaFilter />&nbsp;&nbsp;Assign Product</span><button onClick={(event) => { event.stopPropagation(); closePopup(); }} style={{ paddingRight: 12, height: '30px', backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }}><IoClose /></button></div>
                        <div className="client-grid-container" >
                            <div className="grid-item">
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={productmenuList}
                                    value={selectedProduct}
                                    onChange={(event, newValue: any) => {
                                        setInputs((values: any) => ({ ...values, "CS_PRD_ID": newValue != null ? newValue.OptionID : '' }));
                                        setSelectedProduct(newValue);
                                        setError((prevErrors) => ({ ...prevErrors, CS_PRD_ID: "" }));
                                    }}
                                    getOptionLabel={(option: any) => option.OptionName}
                                    isOptionEqualToValue={(option, value) => option.OptionName === value.OptionName}
                                    sx={{ width: 200, overflowY: 'auto', overflowX: 'hidden' }}
                                    renderOption={(props, option, index) => {

                                        return (
                                            <Box component="li" {...props} >
                                                {option.OptionName}
                                            </Box>
                                        );
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Product List"
                                            variant="standard"
                                            name="CS_PRD_ID"
                                            error={!!error.CS_PRD_ID}
                                            helperText={error.CS_PRD_ID}
                                            InputLabelProps={{
                                                style: {
                                                    color: '#243C5C',
                                                    fontSize: '12px',
                                                    borderColor: 'red',

                                                },
                                            }}
                                            FormHelperTextProps={{
                                                style: {
                                                    fontSize: error.CS_PRD_ID ? '9px' : '12px',

                                                },
                                            }}
                                        />
                                    )}
                                />
                            </div>
                            <div className="grid-item">
                                <TextField id="standard-basic" variant="standard" name="Product_Count" value={inputs["Product_Count"]} label="Product Count"
                                    onChange={(event) => { handleChange(event); }}
                                    error={!!error?.Product_Count}
                                    helperText={error.Product_Count}
                                    InputProps={{
                                        style: {
                                            color: '#243C5C',
                                            fontSize: '14px',
                                            width: '100px',
                                            borderColor: 'red'
                                        }

                                    }}
                                    InputLabelProps={{
                                        style: {
                                            color: '#243C5C',
                                            fontSize: '12px',
                                            borderColor: 'red',

                                        },
                                    }}
                                    FormHelperTextProps={{
                                        style: {
                                            fontSize: error.Product_Count ? '9px' : '12px',

                                        },
                                    }}
                                />
                            </div>
                            <div className="grid-item">
                                <button className={`btn123 `} onClick={() => {
                                    handleGenerateProductKeybtn();
                                }} style={{ padding: 14, backgroundColor: 'var(--body-main-dark-color)', color: '#fff', width: 'fitcontent' }}>Generate&nbsp;Product&nbsp;Key</button>
                            </div>
                        </div>
                        <div className="p-4 font-sans" style={{ padding: '15px' }}>
                            <table
                                style={{
                                    marginTop: "10px",
                                    width: "99%",
                                    borderCollapse: "collapse",
                                    boxShadow: '0px 5px 9px 0px rgba(87, 86, 86, 0.66)',
                                }}
                            >
                                <thead>
                                    <tr style={{ color: 'var(--body-main-dark-color)', backgroundColor: 'var(--body-main-light-color)', fontSize: '13px', fontWeight: 'bold' }}>
                                        {displayProductColumns.map(col => (
                                            <td
                                                key={col.Column_name}
                                                className="border px-4 py-2 cursor-pointer bg-gray-100"
                                                style={{ padding: "5px" }}
                                            >
                                                {col.Header_name || col.Column_name}
                                            </td>

                                        ))}
                                        <td></td>
                                    </tr>
                                </thead>
                                <tbody style={{ background: 'var(--button-color-light)' }}>
                                    {currentRows.map((row, idx) => (
                                        <tr key={idx} className="odd:bg-white even:bg-gray-50">
                                            {displayProductColumns.map(col => {
                                                if (col.Field_Type == 'DATE') {
                                                    return (
                                                        <td key={col.Column_name} className="border px-4 py-2"
                                                            style={{ padding: "5px", fontSize: "13px" }}>
                                                            {new Date(row[col.Column_name]).toLocaleDateString('en-GB', {
                                                                day: '2-digit',
                                                                month: '2-digit',
                                                                year: 'numeric',
                                                                hour: '2-digit',
                                                                minute: '2-digit',
                                                                hour12: true,
                                                            })}
                                                        </td>
                                                    )
                                                }
                                                else if (col.Field_Type === 'TEXTFIELD') {
                                                    return (
                                                        <td key={col.Column_name} className="border px-4 py-2"
                                                            style={{ padding: "5px", fontSize: "13px" }}>

                                                            <TextField
                                                                variant="standard"
                                                                name={col.Column_name}
                                                                onChange={(event) => handleStoreChange(event, row, col)}
                                                                InputProps={{
                                                                    style: {
                                                                        color: '#243C5C',
                                                                        fontSize: '14px',
                                                                        width: '100px',
                                                                    }
                                                                }}
                                                                InputLabelProps={{
                                                                    style: {
                                                                        color: '#243C5C',
                                                                        fontSize: '12px',
                                                                    },
                                                                }}
                                                                FormHelperTextProps={{
                                                                    style: {
                                                                        //fontSize: error?.[col.Column_name] ? '9px' : '12px',
                                                                    },
                                                                }}
                                                            />

                                                        </td>
                                                    )
                                                }
                                                else {
                                                    return (
                                                        <td key={col.Column_name} className="border px-4 py-2"
                                                            style={{ padding: "5px", fontSize: "13px" }}>
                                                            {row[col.Column_name]}
                                                        </td>
                                                    )
                                                }

                                            }
                                            )}
                                            <td>
                                                <IconButton aria-label="select" sx={{ color: 'var(--body-main-dark-color)' }}><Edit /></IconButton>
                                                <IconButton aria-label="select" sx={{ color: 'var(--body-main-dark-color)' }} onClick={() => deleteMapProduct(row)}><DeleteIcon /></IconButton>
                                            </td>
                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                            <div className="pagination-container" style={{ background: 'var(--button-color-light)', boxShadow: '0px 5px 9px 0px rgba(87, 86, 86, 0.66)', width: '99%', color: 'var(--sidebar-bg-dark)', fontSize: '13px', padding: '10px 0px 10px 0px' }}>
                                <Box sx={{ flexShrink: 0, ml: 2.5 }}>

                                    Rows per Page &nbsp;&nbsp;&nbsp;
                                    <FormControl variant="standard" sx={{ minWidth: 20, }}>
                                        <Select
                                            labelId="demo-simple-select-standard-label"
                                            id="demo-simple-select-standard"
                                            value={rowsPerPage}
                                            onChange={(e) => setRowsPerPage(e.target.value)}
                                            disabled={true}
                                        >
                                            <MenuItem value={5}>5</MenuItem>
                                            <MenuItem value={10}>10</MenuItem>
                                            <MenuItem value={30}>30</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <span> &nbsp;&nbsp;{indexOfFirstRow + 1} - {indexOfLastRow}&nbsp;&nbsp; of &nbsp;&nbsp; {productKeyList.length}</span>
                                    <IconButton
                                        onClick={() => setCurrentPage(1)}
                                        disabled={currentPage === 0}
                                        aria-label="first page"
                                    >
                                        <FirstPageIcon />
                                    </IconButton>
                                    <IconButton
                                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                        disabled={currentPage === 0}
                                        aria-label="previous page"
                                    >
                                        <KeyboardArrowLeft />

                                    </IconButton>
                                    <IconButton
                                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                        disabled={currentPage === totalPages}
                                        aria-label="next page"
                                    >
                                        <KeyboardArrowRight />
                                    </IconButton>
                                    <IconButton
                                        onClick={() => setCurrentPage(Math.max(0, Math.ceil(productKeyList.length / rowsPerPage)))}
                                        disabled={currentPage === totalPages}
                                        aria-label="last page"
                                    >
                                        <LastPageIcon />
                                    </IconButton>
                                </Box>
                            </div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px 20px' }}>
                            <div>
                                <button className='btn123' style={{ paddingRight: 12, height: '30px' }}><GrPowerReset />&nbsp;Reset</button>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <button className='btn123' onClick={(event) => { event.stopPropagation(); InsertProductKeyList(); }} style={{ paddingRight: 12, height: '30px' }}><Save /> &nbsp;Save</button>&nbsp;
                                <button className='btn123' onClick={(event) => { event.stopPropagation(); closePopup() }} style={{ paddingRight: 12, height: '30px' }}><IoClose />&nbsp;Close</button>
                            </div>
                        </div>
                    </div>
                </>
            </Popup>

        )}


    </>);
}

export default ProductKeyListMaster;